import { isArrayLike } from '../utils';

function each(target, callback) {
  if (isArrayLike(target)) {
    for (let i = 0; i < target.length; i += 1) {
      if (callback.call(target[i], i, target[i]) === false) {
        return target;
      }
    }
  } else {
    const keys = Object.keys(target);

    for (let i = 0; i < keys.length; i += 1) {
      if (callback.call(target[keys[i]], keys[i], target[keys[i]]) === false) {
        return target;
      }
    }
  }

  return target;
}

export default each;